function placeholders() {
  let placeholder = '';

  for (let i = 0; i < 500; i += 20) {
    placeholder += `
       .p-h--${i} {
          height: ${i}px !important;
          border-radius: 6px;

          animation-duration: 1s;
          animation-fill-mode: forwards;
          animation-iteration-count: infinite;
          animation-name: placeHolderShimmer;
          animation-timing-function: linear;
          background: #f6f7f8;
          background: linear-gradient(to right, #fafafa 8%, #f4f4f4 38%, #fafafa 54%);
          background-size: 1000px 640px;
          position: relative;

          * {
            opacity: 0;
          }
       }
     `;

    placeholder += `
       .p-w--${i} {
          width: ${i}px !important;
       }
     `;
  }

  return placeholder;
}

export default placeholders;
